import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { AddToCartModel, ProductModel } from '@libs/shop/models';
import { ProductImpressionDirective } from '@libs/shared/tracking';
import { ProductCardComponent } from '../product-card';

@Component({
  selector: 'ui-product-list',
  imports: [
    ProductCardComponent,
    ProductImpressionDirective,
  ],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListComponent {
  public addToShoppingList: OutputEmitterRef<AddToCartModel<ProductModel>> = output();

  public products: InputSignal<ProductModel[]> = input.required();
  public highlightedProducts: InputSignal<ProductModel[]> = input([] as ProductModel[]);
  public indexBase: InputSignal<number> = input(0);
}
